import React, { memo } from "react";
import PropTypes from "prop-types";

import Table from "../../../common/Table";
import Row from "../../../common/Row";
import { Popup } from 'semantic-ui-react';

const GemeenteOverzichtAanvragenForm = (props) => {
    const {
        openAanvragenModels,
        onEditSportclub,
    } = props;


    const tdStyle = { padding: "5px" };

    function returnTdContent(text) {
        return text.length > 40 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 40) + "..."}</p>} content={text} /> : text;
    }

    function handleOnEditSportclub(id, isNew, isReadonly) {
        return function () {
            onEditSportclub(id, isNew, isReadonly);
        };
    }

    function getAanvraagActions(aanvraag) {
        return (
            <td style={{ paddingBottom: '2px', paddingTop: '2px' }}>
                {aanvraag.aanvraagType === "Unlink" ? null :
                    (aanvraag.status === "Onvolledig" || aanvraag.status === "Aanvraag") ?
                        <Popup wide="very" trigger={< i className="fa fa-pencil" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(aanvraag.sportclubId, aanvraag.aanvraagType === "Create", false)} />} content={"Bekijk detail/ wijzig sportclub"} position="left center" />
                        : <Popup wide="very" trigger={<i className="fa fa-eye" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(aanvraag.sportclubId, false, true)} />} content={"Toon detail sportclub. Je kan deze sportclub niet wijzigen omdat Sport Vlaanderen momenteel een wijzigingsaanvraag van deze sportclub verwerkt."} position="left center" />}
            </td>
        );
    }

    const aanvragenRows = openAanvragenModels.map((aanvraag, i) => {
        return (
            <tr className={aanvraag.aanvraagType === "Unlink" ? 'crossedText' : null} style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '100%' }} key={i} height="80">
                <td style={tdStyle}>{returnTdContent(aanvraag.sportclubNaam)}</td>
                <td style={tdStyle}>{returnTdContent(aanvraag.gemeente)}</td>
                <td style={tdStyle}>{returnTdContent(aanvraag.aanvrager)}</td>
                <td style={tdStyle}>{returnTdContent(aanvraag.status)}</td>
                {getAanvraagActions(aanvraag)}
            </tr>
        );
    });

    return (
        <div className="o-col-12" id="aanvragenForm">
            <Row>
                <Table
                    title={"Openstaande aanvragen"}
                    headers={["Naam (Afkorting)", "Gemeente", "Indegiend door", "Status", ""]}
                    headerSizes={[36, 20, 24, 14, 10]}
                >
                    {aanvragenRows}
                </Table>
            </Row>
        </div>
    );
};

GemeenteOverzichtAanvragenForm.propTypes = {
    openAanvragenModels: PropTypes.array,
    onEditSportclub: PropTypes.func,
};

export default GemeenteOverzichtAanvragenForm;